<msf-list-page-wrapper
  [leftSize]="'9'"
  [rightSize]="'3'"
  [rightBackground]="true">
  <div
    left
    #left>
    <div class="page-header">
      @if (backButton) {
        <app-back-button
          [title]="title | translate"
          [subtitle]="subtitle | translate"
          [parentRoute]="parentRoute"></app-back-button>
      }

      <div class="header-actions">
        <ng-content select="[controller]"></ng-content>
      </div>
    </div>
    <app-dynamic-data-table
      [(loading)]="isLoading"
      (onRowClick)="onRowClick.emit($event)"
      [service]="service"
      [getAllMethod]="getAllMethod"
      [getTotalMethod]="getTotalMethod"
      [filter]="filtersParams"
      (OnFilterSaved)="filterSaved($event)"
      [defaultParams]="defaultParams"
      [toggleFilter]="toggleFilter"
      [storageKey]="storageKey"
      [columns]="columns"
      [methodWithParams]="methodWithParams"
      (currentPageData)="currentPageData.emit($event)"
    ></app-dynamic-data-table>
  </div>

  <div
    right
    #right>
    <msf-filters
      [fields]="filtersForms"
      [(ngModel)]="filterModel"
      (applyFilter)="filterModelChange.emit(filterModel); applyFilters.emit(filterModel)"
      (clearFilter)="clearFilters.emit()"
      [isLoading]="isLoading"
      [background]="filterBackground" />
  </div>
</msf-list-page-wrapper>
